import { EnvGroup } from '@flakiness/server/common/stats/envGroup.js';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { PlaneName } from '../features/feature-tests-report.js';
import { hrefOrClick, Linkifier } from '../linkifier.js';

type NoDataMessageState = {
  timelineSplit?: EnvGroup,
  plane?: PlaneName,
  query?: string,
}

@customElement('no-data-message')
class NoDataMessage extends LitElement {
  @property({ attribute: false }) state?: NoDataMessageState;
  @property({ attribute: false }) linker?: Linkifier<NoDataMessageState>;

  private _getMessage(plane: PlaneName) {
    if (this.state?.query) {
      if (plane === 'tests')
        return html`No Tests Matching Filter.`;
      if (plane === 'annotations')
        return html`No Annotations Matching Filter.`;
      if (plane === 'errors')
        return html`No Errors Matching Filter.`;
      if (plane === 'tags')
        return html`No Tags Matching Filter.`;
      if (plane === 'timelines')
        return html`No Environments Matching Filter.`;
    }

    if (this.state?.timelineSplit && !this.state?.timelineSplit.acceptsAll()) {
      if (plane === 'tests')
        return html`No Tests in Selected Testing Environments.`;
      if (plane === 'annotations')
        return html`No Annotations in Selected Testing Environments.`;
      if (plane === 'errors')
        return html`No Errors in Selected Testing Environments.`;
      if (plane === 'tags')
        return html`No Tags in Selected Testing Environments.`;
      if (plane === 'timelines')
        return html`No Environments in Selected Testing Environments.`;
    }

    if (plane === 'tests')
      return html`No Tests`;
    if (plane === 'annotations')
      return html`No Annotations`;
    if (plane === 'errors')
      return html`No Errors`;
    if (plane === 'tags')
      return html`No Tags`;
    if (plane === 'timelines')
      return html`No Environments`;
  }

  render() {
    const plane = this.state?.plane ?? 'tests';
    const msg = this._getMessage(plane);
    
    return html`
      <section>
      <div class=message>
        ${msg}
      </div>
        ${this.state?.query ? html`
          <a ${hrefOrClick(this.linker?.({ query: undefined }))}>Reset filter</a>
        ` : this.state?.timelineSplit && !this.state?.timelineSplit.acceptsAll() ? html`
          <a ${hrefOrClick(this.linker?.({ timelineSplit: undefined }))}>Show all test environments instead.</a>
        ` : nothing}
      </section>
    `;
  }

  static styles = css`
    :host {
      display: flex;
      flex: auto;
    }

    .message {
      color: var(--sl-color-neutral-400);
      font-size: var(--sl-font-size-medium);
      margin: var(--sl-spacing-medium) 0;
    }

    a {
      all: unset;
      cursor: pointer;
      text-decoration: underline;
    }
  `;

}
